<template>
  <div class="pa-0">
    <!-- TYPES [soundcloud, ....] -->
    <div
      :key="attachmentsTypeName"
      v-for="(attachmentsType, attachmentsTypeName) in attachmentTypes"
    >
      <div
        class="pa-5 mb-6"
        style="border: 1px solid #eee"
        v-if="record[`${attachmentsTypeName}_attachments`].length > 0"
      >
        <!-- ATTACHMENTS LIST TITLE -->
        <h4 class="mb-2">
          <v-icon class="ml-1">mdi-paperclip</v-icon>
          مرفقات
          {{ attachmentsType.label }}
        </h4>

        <hr class="light-divider" />

        <!-- ATTACHMENTS LIST -->
        <v-row>
          <v-col
            class="text-center"
            md="4"
            cols="12"
            :key="index"
            v-for="(attachment, index) in record[`${attachmentsTypeName}_attachments`]"
          >
            <!-- NAME -->
            <p class="mb-2">{{ attachment.name ? attachment.name : 'لايوجد اسم' }}</p>

            <!-- VIEW: (video, image, link, ..) -->
            <attachment-view :attachment="attachment" />

            <!-- DELETE OPTION -->
            <v-btn
              v-if="deleteMode"
              small
              icon
              color="error"
              class="mx-2 mt-3"
              :loading="loading"
              @click="removeAttachment(attachment.id)"
            >
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>


<script>
import AttachmentView from './View';

export default {
  name: 'attachments',
  props: ['record', 'deleteMode'],
  components: { AttachmentView },


  data: function () {
    return {
      loading: false,
      attachmentTypes: {
        soundcloud: { label: 'صوتيات ساوندكلاود' },
        video: { label: 'فيديوهات يوتيوب' },
        image: { label: 'صور' },
        pdf: { label: 'ملفات pdf' },
        other: { label: 'ملفات أخرى' }
      },
    };
  },


  methods: {
    removeAttachment(attachmentId) {
      this.loading = true;

      this.axios.delete(`/admin/attachments/${attachmentId}`)
        .then(() => {
          this.$bus.$emit("showSnackbar", {
            text: "تم حذف المرفق بنجاح",
            color: "success",
          });

          this.$emit('update');
        })
        .catch((error) => {
          this.$bus.$emit("showSnackbar", {
            text: "تعذر حذف المرفق",
            color: "accent",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
}
</script>